
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'whitespace-nowrap cursor-pointer font-medium transition-all duration-300 rounded-lg';
  
  const variants = {
    primary: 'bg-lumaz-secondary hover:bg-lumaz-primary text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-lumaz-primary hover:bg-lumaz-secondary text-white shadow-lg hover:shadow-xl',
    outline: 'border-2 border-lumaz-secondary text-lumaz-secondary hover:bg-lumaz-secondary hover:text-white'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
